// Consume both halves of Escape: legacy parent dialogs close on keyup.
export function guardModalEscape(close) {
	let active = true
	let held = false
	const removeReleaseListeners = () => {
		window.removeEventListener('keyup', onKeyup, true)
		window.removeEventListener('blur', onBlur)
	}
	const onKeydown = event => {
		if (event.key !== 'Escape') return
		held = true
		event.preventDefault()
		event.stopImmediatePropagation()
		close()
	}
	const onKeyup = event => {
		if (event.key !== 'Escape' || !held) return
		held = false
		event.preventDefault()
		event.stopImmediatePropagation()
		if (!active) removeReleaseListeners()
	}
	const onBlur = () => {
		held = false
		if (!active) removeReleaseListeners()
	}
	window.addEventListener('keydown', onKeydown, true)
	window.addEventListener('keyup', onKeyup, true)
	window.addEventListener('blur', onBlur)
	return () => {
		active = false
		window.removeEventListener('keydown', onKeydown, true)
		// The chooser can unmount on keydown, before the parent receives keyup.
		if (!held) removeReleaseListeners()
	}
}
